import React from 'react';
import { Slide } from '../../components/deck/Slide';
import { Eyebrow, INK, Reveal, Title } from '../../components/deck/Type';
const SERIF = {
  fontFamily: 'var(--font-serif)'
} as const;
const forces = [{
  name: 'Foundation models leapt forward',
  line: 'Reasoning is now good enough for professional analysis.',
  tone: INK.blue
}, {
  name: 'Enterprises are experimenting',
  line: 'Investment, research and corporate teams are piloting AI.',
  tone: INK.blue
}, {
  name: 'Generic AI is hitting limits',
  line: 'Inconsistent outputs, privacy concerns, rising usage costs.',
  tone: INK.gold
}, {
  name: 'Unstructured data is growing',
  line: 'Decks, data rooms, updates and filings multiply every year.',
  tone: INK.violet
}, {
  name: 'Specialized AI infrastructure',
  line: 'Value is shifting to the layers around the models.',
  tone: INK.emerald
}, {
  name: 'Diligence must move faster',
  line: 'More deal flow, same analyst capacity.',
  tone: INK.emerald
}];
export function WhyNowSlide() {
  return <Slide data-id="element-463" data-mp="2gs31h7zvo5xg">
      <Eyebrow data-id="element-464" data-mp="2gqi2n66j60ts">Why now</Eyebrow>
      <Title className="mt-[2.2cqh] max-w-[70%]" data-id="element-465" data-mp="2gqrt0uvhma00">
        The models are ready. The institutional infrastructure isn&apos;t.
      </Title>

      <div className="mt-auto grid grid-cols-3 gap-x-[2.4cqw] gap-y-[4cqh]" data-id="element-466" data-mp="271i4fozur9gn">
        {forces.map((f, i) => <Reveal key={f.name} delay={0.05 * i} className="border-t border-white/12 pt-[2.2cqh]" data-id="element-467" data-mp="230y6wkbda3tz" data-mpi={i}>
            <div className="flex items-center gap-[0.8cqw]" data-id="element-468" data-mp="1y1btoavjgnl6">
              <span className="text-[0.8cqw] tracking-[0.22em] text-white/35" data-id="element-469" data-mp="1xypblhb0upop">{String(i + 1).padStart(2, '0')}</span>
              <span className="h-px w-[2cqw]" style={{
            background: f.tone
          }} aria-hidden data-id="element-470" data-mp="1o2ma8dnzuv2t" />
            </div>
            <p className="mt-[1.6cqh] text-[1.7cqw] leading-tight text-[#F4F7FC]" style={SERIF} data-id="element-471" data-mp="1k1slxj6n3e9e">
              {f.name}
            </p>
            <p className="mt-[1.2cqh] text-[1.02cqw] leading-snug text-[#8B95A8]" data-id="element-472" data-mp="3iflyev6fwxlp">{f.line}</p>
          </Reveal>)}
      </div>
    </Slide>;
}